import {DemoProjectFilterValue} from './components/Controls/DemoProjectControl';
import {ProposalFilterValue} from './components/Controls/ProposalControl';
import {ScalabilityFilterValue} from './components/Controls/ScalabilityControl';
import {ExcludeFilterValue} from './components/Controls/ExcludeControl';
import {ValidateFilterValue} from './components/Controls/ValidateControl';
import {VisibleFilterValue} from './components/Controls/VisibleControl';

/*eslint eqeqeq: "off"*/
export function textMatch(value, filter) {
    if (filter == null || filter === '') return true;

    if (filter === "''") return value == null || value === '';
    else return value?.toLowerCase().includes(filter.toLowerCase());
}

function removeOperatorFromString(filter: string) {
    return filter.replace('>', '').replace('<', '').replace('=', '');
}

function numberMatchWithOperators(value: number, filter: string) {
    const operatorRemoved = removeOperatorFromString(filter);
    const filterNumber = parseFloat(operatorRemoved);

    if (isNaN(filterNumber)) return true;

    if (filter.includes('>=') || filter.includes('=>')) {
        return value !== null && value >= filterNumber;
    }
    if (filter.includes('<=') || filter.includes('=<')) {
        return value !== null && value <= filterNumber;
    }
    if (filter.includes('>')) {
        return value !== null && value > filterNumber;
    }
    if (filter.includes('<')) {
        return value !== null && value < filterNumber;
    }
    if (filter.includes('=')) {
        return filterNumber === value;
    }
}

function containsOperator(filter: string) {
    if (!filter) return false;

    if (
        filter.includes('=') ||
        filter.includes('<') ||
        filter.includes('>') ||
        filter.includes('<=') ||
        filter.includes('=<') ||
        filter.includes('>=') ||
        filter.includes('=>')
    )
        return true;

    return false;
}

export function numberMatch(value, filter) {
    if (filter !== null && containsOperator(filter)) return numberMatchWithOperators(value, filter);

    if (filter == null || filter === '') return true;

    if (filter === "''") return value == null;
    else return value == filter;
}

export function numberRangeMatch(low, hi, filter) {
    if (filter == null || filter === '') return true;

    if (filter === "''") return low == null || hi == null;
    else if (low == null) return filter == hi;
    else if (hi == null) return filter == low;
    else return low <= filter && filter <= hi;
}

export function booleanMatch(value, filter) {
    if (filter == null || filter === '') return true;

    if (filter === "''" || filter.toLowerCase() === 'n') return !value;
    else return filter.toLowerCase() === 'y' && value;
}

export function validatedMatch(value: boolean, filter: ValidateFilterValue) {
    switch (filter) {
        case ValidateFilterValue.Unset:
            return true;
        case ValidateFilterValue.Validated:
            return value;
        case ValidateFilterValue.Unvalidated:
            return !value;
        default:
            return true;
    }
}

export function demoProjectMatch(value: boolean, filter: DemoProjectFilterValue) {
    switch (filter) {
        case DemoProjectFilterValue.Unset:
            return true;
        case DemoProjectFilterValue.DemoProject:
            return value;
        case DemoProjectFilterValue.NotDemoProject:
            return !value;
        default:
            return true;
    }
}

export function proposalMatch(value: boolean, filter: ProposalFilterValue) {
    switch (filter) {
        case ProposalFilterValue.Unset:
            return true;
        case ProposalFilterValue.Proposal:
            return value;
        case ProposalFilterValue.NotProposal:
            return !value;
        default:
            return true;
    }
}

export function scalabilityMatch(value: boolean, filter: ScalabilityFilterValue) {
    switch (filter) {
        case ScalabilityFilterValue.Unset:
            return true;
        case ScalabilityFilterValue.Scalable:
            return value;
        case ScalabilityFilterValue.NotScalable:
            return !value;
        default:
            return true;
    }
}

export function visibilityMatch(value: boolean, filter: VisibleFilterValue) {
    switch (filter) {
        case VisibleFilterValue.Unset:
            return true;
        case VisibleFilterValue.Visible:
            return value;
        case VisibleFilterValue.NotVisible:
            return !value;
        default:
            return true;
    }
}

export function excludedMatch(value: boolean, filter: ExcludeFilterValue) {
    switch (filter) {
        case ExcludeFilterValue.Unset:
            return true;
        case ExcludeFilterValue.Excluded:
            return value;
        case ExcludeFilterValue.NotExcluded:
            return !value;
        default:
            return true;
    }
}
